import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import MobileLayout from '../layouts/MobileLayout';
import MobilePackCard from '../components/MobilePackCard';
import { packsApiService, Pack } from '../../services/packsApi';

const MobilePacksPage: React.FC = () => {
  const navigate = useNavigate();
  const [packs, setPacks] = useState<Pack[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPacks();
  }, []);

  const loadPacks = async () => {
    try {
      setLoading(true);
      const packsData = await packsApiService.getPacks(true);
      setPacks(packsData);
    } catch (error) {
      console.error('Erreur lors du chargement des packs:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MobileLayout>
      {/* Header */}
      <div className="bg-gradient-to-br from-gray-900 to-gray-800 px-4 py-6">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-amber-200 mb-4"
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="text-sm">Retour</span>
        </button>
        <h1 className="text-2xl font-bold text-white mb-2">Nos Packs</h1>
        <p className="text-sm text-gray-300">
          Des forfaits adaptés à tous les budgets
        </p>
      </div>

      {/* Packs List */}
      <section className="px-4 py-6 bg-gradient-to-br from-gray-50 to-amber-50/20">
        {loading ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-amber-600 mx-auto"></div>
            <p className="text-gray-600 mt-4 text-sm">Chargement des packs...</p>
          </div>
        ) : packs.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-600">Aucun pack disponible pour le moment.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-4">
            {packs.map((pack, index) => (
              <MobilePackCard
                key={pack.id}
                name={pack.name}
                price={`${pack.total_price}`}
                features={[
                  pack.description,
                  `${pack.services.length} service${pack.services.length > 1 ? 's' : ''} inclus`,
                  ...(pack.services.map(s => s.name))
                ]}
                isPopular={index === 1}
                onClick={() => {
                  // TODO: Navigate to pack detail or devis request
                  navigate('/devisrequest');
                }}
              />
            ))}
          </div>
        )}
      </section>

      {/* CTA */}
      <section className="px-4 py-6">
        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-6 text-center">
          <h2 className="text-xl font-bold text-white mb-2">
            Pack personnalisé ?
          </h2>
          <p className="text-sm text-gray-300 mb-4">
            Contactez-nous pour un devis sur mesure
          </p>
          <button
            onClick={() => navigate('/contact')}
            className="w-full py-3 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-xl font-medium shadow-lg"
          >
            Demander un devis
          </button>
        </div>
      </section>
    </MobileLayout>
  );
};

export default MobilePacksPage;
